import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteAffiliation } from '~/services/AgentHub/AgentService';

import { affiliationsQueryKeys } from './useListAffiliations';

interface UseDeleteAffiliationOptions {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export function useDeleteAffiliation(options: UseDeleteAffiliationOptions = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (affiliationId: string) => {
      return await deleteAffiliation(affiliationId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: affiliationsQueryKeys.all });
      options.onSuccess?.();
    },
    onError: (error: Error) => {
      options.onError?.(error);
    },
  });
}
